import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations from files
import tr from '../locales/tr';
import en from '../locales/en';

// Translation resources loaded from files
const resources = {
  tr: {
    translation: tr
  },
  en: {
    translation: en
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr',
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Re-export useTranslation from react-i18next for convenience
export { useTranslation } from 'react-i18next';

// Change language function
export const changeLanguage = async (lng) => {
  await i18n.changeLanguage(lng);
  return { success: true };
};

// Clear translation cache (for file-based system, this just reloads the page)
export const clearTranslationCache = () => {
  // For file-based system, we can't really clear cache
  // But we can reload the page to refresh translations
  return true;
};

export default i18n;
